module.exports = __webpack_public_path__ + "static/media/new_feature_icon.18187dde.svg";